<template>
  <div class="row border-bottom border-danger my-5">
    <h1 class="text-center text-uppercase mt-3" id="header">
      Maak uw keuze uit ons assortiment
    </h1>
  </div>
  <div
    class="container-tiles row justify-content-start mx-auto w-75 fontSizeCard"
  >
    <template v-for="(tile, key) in Tiles" :key="key">
      <div class="col-3">
        <SelectionTile :tile="tile" />
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import SelectionTile from "@/components/SelectionTile.vue";

export default {
  name: "Assortiment",
  components: {
    SelectionTile,
  },
  data() {
    return {
      classes: {
        link: "bg-light p-0 border border-1 mb-2 tiles",
        img: "border-bottom border-1 card-img",
        text: "card-body text-dark fontSizeCard text-uppercase",
        icon: "bi bi-arrow-right-circle",
      },
      Tiles: {},
      //end return
    };
    // end data
  },
  created() {
    this.buildTiles();
    this.$store.commit("storeLocUpdate", true);
  },
  beforeUpdate() {
    this.$store.commit("storeLocUpdate", true);
  },
  methods: {
    async buildTiles() {
      let Tiles = {};

      // get assortiment data
      const assortiments = await this.$Functions.getData(
        "assortiment",
        this.$store.getters.getLang
      );

      const langCode = this.$store.getters.getLang.split("-");
      const lang = langCode[0];

      // build assortiment tiles
      for (let tileIndex = 0; tileIndex < assortiments.length; tileIndex++) {
        // add assortiment to tiles if equal to orderNr
        for (
          let assortimentIndex = 0;
          assortimentIndex < assortiments.length;
          assortimentIndex++
        ) {
          if (tileIndex == assortiments[assortimentIndex].orderNr) {
            Tiles[tileIndex] = {
              // classes
              selectors: {
                class: {
                  link: this.classes.link,
                  img: this.classes.img,
                  text: this.classes.text,
                  icon: this.classes.icon,
                },
                id: {
                  text: tileIndex + "-text",
                },
              },
              properties: {
                link: `${lang}-${assortiments[assortimentIndex].code}`,
                imgAlt: assortiments[assortimentIndex].imagePath,
                imgSrc: assortiments[assortimentIndex].imagePath,
                text: assortiments[assortimentIndex].label,
              },
            };
          }

          // end assortiment loop
        }

        // end tiles loop
      }

      this.Tiles = Tiles;
      return true;
      // end buildTiles
    },
    // end methods
  },
  watch: {
    "$store.getters.getLang": function () {
      this.buildTiles();
    },
    "$route.path": function () {
      this.$store.commit("storeLocUpdate", true);
    },
  },
};
</script>
<style scoped></style>
